import React from "react";

/**
 * Tab 4 — הערות ודיווחים (Notes)
 */
export default function LoanFormTab4({ loan, onChange }) {
  return (
    <div className="form-grid">
      {/* ── Disclosures ──────────────────────────────────── */}
      <h3 className="form-section-header">דיווחים</h3>

      <div className="field form-full-width">
        <label className="label-optional">דיווחים נדרשים ותדירות <span className="optional-badge">(אופציונלי)</span></label>
        <textarea
          className="textarea"
          name="disclosures"
          value={loan.disclosures}
          onChange={onChange}
          rows={5}
          placeholder="הגדר אילו דוחות נדרשים ובאיזו תדירות (למשל: דוחות כספיים רבעוניים, ביקורת שנתית)"
        />
        <small style={{ color: "var(--text-secondary)", fontSize: "12px", marginTop: "4px", display: "block" }}>
          פרט אילו דוחות נדרשים ובאיזו תדירות (למשל: דוחות כספיים רבעוניים, ביקורת שנתית)
        </small>
      </div>

      {/* ── Notes ────────────────────────────────────────── */}
      <h3 className="form-section-header">הערות</h3>

      <div className="field form-full-width">
        <label className="label-optional">הערות ספציפיות <span className="optional-badge">(אופציונלי)</span></label>
        <textarea
          className="textarea"
          name="notes"
          value={loan.notes}
          onChange={onChange}
          rows={3}
          placeholder="הערות ספציפיות לתנאי ההלוואה, אירועים, שינויים בתנאים..."
        />
        <small style={{ color: "var(--text-secondary)", fontSize: "12px", marginTop: "4px", display: "block" }}>
          הערות ספציפיות לתנאי ההלוואה הנוכחית
        </small>
      </div>

      <div className="field form-full-width">
        <label className="label-optional">הערות כלליות <span className="optional-badge">(אופציונלי)</span></label>
        <textarea
          className="textarea"
          name="generalNotes"
          value={loan.generalNotes}
          onChange={onChange}
          rows={3}
          placeholder="הערות כלליות על הלווה, הפרויקט, או ההיסטוריה של ההלוואה..."
        />
        <small style={{ color: "var(--text-secondary)", fontSize: "12px", marginTop: "4px", display: "block" }}>
          רקע כללי, היסטוריה, או הערות לא מובנות
        </small>
      </div>
    </div>
  );
}
